import { Component, OnInit, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TermsPromptService } from './terms-prompt.service';

@Component({
  selector: 'app-terms-prompt',
  imports: [DatePipe, RouterLink],
  templateUrl: './terms-prompt.component.html',
  styleUrl: './terms-prompt.component.scss',
  standalone: true,
})
export class TermsPromptComponent implements OnInit {
  readonly prompt = inject(TermsPromptService);

  ngOnInit(): void {
    this.prompt.check();
  }
}
